<nav class="navbar navbar-expand-lg">
  <div class="container-fluid">
    <a class="navbar-brand" routerLink="/">{{ environment.production ? '' : 'DEV ' }}Cast Scheduling Profile</a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
      <i class="bi bi-list text-white"></i>
    </button>
    <div class="collapse navbar-collapse" id="navbarNavDropdown">
      @if (authService.authUser) {
        <ul class="navbar-nav me-auto">
          <li class="nav-item">
            <a class="nav-link" aria-current="page" routerLink="/profile">
              {{ languageService.getTranslation('NAVBAR.YOUR_PROFILE') | async }}
            </a>
          </li>
          @if (permissionsService.canSchedule || permissionsService.canView) {
            <li class="nav-item">
              <a class="nav-link" aria-current="page" routerLink="/scheduler">Scheduler</a>
            </li>
          }
          @if (permissionsService.canBuild || permissionsService.canManage) {
            <li class="nav-item">
              <a class="nav-link" aria-current="page" routerLink="/profile-templates">Profile Builder</a>
            </li>
          }
          @if (permissionsService.canView) {
            <li class="nav-item">
              <a class="nav-link" aria-current="page" routerLink="/insights">Insights</a>
            </li>
          }
          @if (permissionsService.canManage || permissionsService.isAdmin || permissionsService.isSuperAdmin) {
            <li class="nav-item">
              <a class="nav-link" aria-current="page" routerLink="/admin">Admin</a>
            </li>
          }
        </ul>
        <div class="d-flex flex-wrap">
          <div>
            <select class="form-select form-select-sm" [(ngModel)]="languageService.activeLanguage" (ngModelChange)="updateActiveLanguage($event)">
              <option value="en">English</option>
              <option value="es">Español</option>
            </select>
          </div>
          <button type="button" class="btn ms-3 mb-2 mb-lg-0" routerLink="/logout">
            {{ languageService.getTranslation('NAVBAR.SIGN_OUT') | async }}
          </button>
        </div>
      }
    </div>
  </div>
</nav>
<div class="user-img-section">
  <div class="session-timer">
    <div class="circle" #circle></div>
    <div class="circle-timer">
      <div class="circle-image">
        @if (authService.authUser) {
          <img id="user-img" class="rounded-circle" [src]="authService.authUser.original_photo_url">
        }
      </div>
      <div class="countdown w-100">
        <p class="caption">Time Remaining:<br/>@if (authService.minutesUntilTimeout > 0) {
          <span class="timer">{{ authService.minutesUntilTimeout | number:'1.0-0' }}</span>
          }@if (authService.minutesUntilTimeout > 1) {
          <span> Minutes</span>
          }@if (authService.minutesUntilTimeout == 1) {
          <span> Minute</span>
          }@if (authService.minutesUntilTimeout < 1) {
          <span>{{ authService.secondsUntilTimeout  | number:'2.0-0'  }} Seconds</span>
        }</p>
      </div>
      <div class="info-box">
        <h4 class="info-header">Session Countdown</h4>
        <p class="info-text">This sessoin will expire in <b>{{ authService.minutesUntilTimeout | number:'1.0-0'  }}:{{ authService.secondsUntilTimeout | number:'2.0-0'  }}</b>. Please save your work before that time.</p>
      </div>
    </div>
  </div>
</div>

